import React, { useState } from "react";
import { StyleSheet, css } from "aphrodite";
import { SocialIcon } from 'react-social-icons'
import { Link } from "react-router-dom";


function Footer({display=true}){

    //#region code
    const [activeSections, setActiveSections] = useState([]);

    const showOrHideCheckBox = (filterselected) => {
        const checkBoxes = document.getElementsByClassName(filterselected)
        
        for( var index = 0; index < checkBoxes.length; index++){
            checkBoxes[index].style.cssText  = 
                checkBoxes[index].style.height === "fit-content" ? "height: 0px !important": "height: fit-content !important"  
        }
    
        if(activeSections.includes(filterselected)) {
          let newArr = activeSections.filter((item) => item !== filterselected);
          setActiveSections(newArr)
        } else {
          let newArr = [...activeSections, filterselected]
          setActiveSections(newArr)
        }
    }
    //#endregion
    
    //#region styles
    const styles = StyleSheet.create({
        container: {
            display: "flex",
            flexDirection: "column",
            WebkitUserSelect: 'none',
            MsUserSelect: 'none',
            UserSelect: 'none',
        },
        footer: {
            height: "auto",
            display: "flex",
            flexDirection:'row',
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "darkgray",
            padding: "3% 1rem 3% 1rem",
            /*tablet and bigger screens*/
            "@media (min-width: 1024px)": {
               
                padding: "1% 0% 2% 0%",
            }
        },
        marginContainer: {
            display: "flex",
            flexDirection:'column',
            maxWidth: "1280px",
            width: "100%",
            columnGap: "2rem",
            /*tablet and bigger screens*/
            "@media (min-width: 1024px)": {
                flexDirection:'row',
                justifyContent: 'center'
            }
        },
        firstColumn: {
            display:'flex',
            flexDirection:'column',
            alignItems:'center',
            justifyContent:'center',
            /*tablet and bigger screens*/
            "@media (min-width: 1024px)": {
                display:'flex',
                width:'40%',
                height:'100%',
                alignItems:'flex-end',
            }
        },
  
        firstTitle: {
            fontFamily: "Montserrat",
            fontSize: "1.2rem",
            margin: "5% 0% 5% 0%",
            textAlign: "left",
            color: "#fec803",
            gridColumnStart: "1"
        },
        firstSubtitle: {
            fontFamily: "Montserrat",
            fontSize: "0.9rem",
            margin: "0% 0% 5% 0%",
            textAlign: "left",
            color: "#F0EFEC",
            gridColumnStart: "1",
            /*tablet and bigger screens*/
            "@media (min-width: 1024px)": {
                fontSize: "0.75rem",
            } 
        }, 
        inputContainer: {
            gridColumnStart: "1",
            display: "flex",
            height: "2rem",
            width:'100%',
            // overflow: "hidden",
            /*tablet and bigger screens*/
            "@media (min-width: 1024px)": {
                width: "auto",
            }
        },
        input: {
            border:'none',
            borderTopLeftRadius:'10px',
            borderBottomLeftRadius:'10px',
            backgroundColor: "white",
            width: "100%",
            outline: '2px solid transparent',
            outlineOffset: '2px',
            paddingLeft:'0.2rem'
        },
        secondColumn:{
            width:'100%',
            display: "flex",
            flexDirection: "column",
        },
        linksContainer: {
            display: "none",
            flexDirection: "row",
            height: "100%",
            gap: "40px",
            fontFamily: "Montserrat",
            fontSize: "12px",
            /*tablet and bigger screens*/
            "@media (min-width: 1024px)": {
                display: "flex",
                justifyContent: 'center'
            }
        },
        linksContainerMobile: {
            display: "flex",
            flexDirection: "row",
            height: "100%",
            gap: "40px",
            color:'white',
            fontFamily: "Montserrat",
            fontSize: "12px",
            /*tablet and bigger screens*/
            "@media (min-width: 1024px)": {
                display: "none",
            }
        },
        miniContainer: {
            display: "flex",
            flexDirection: "column",
            flexWrap: "wrap",
            color: "white",
            gap:"20px",
        },
        miniContainerText: {
            fontFamily: "Montserrat",
            fontWeight: "700",
            letterSpacing: "1px",
            fontSize: "15px",
            color: '#fec803'
        },

        linkItem: {
            transition:'0.3s all',
            cursor:'pointer',
            height:'2.5rem',
            fontSize:'1rem',
            display:'flex',
            alignItems:'center',
            justifyContent:'start',
            /*tablet and bigger screens*/
            "@media (min-width: 1024px)": {
                height: "auto",
                ":hover": {
                    color:'#fec803'
                }
            }
        },
        /*Mobile*/
        ulContainer: {
            width: "100%",
            display: "inline-flex",
            flexDirection: "column",
            gap:'1rem',
            fontFamily: "Montserrat",
            backgroundColor: "transparent",
            listStyle: "none",
            position:"relative",
            transition:'0.4s all',
            padding: '10px 0px',
            margin:'0px',
            WebkitUserSelect: 'none',
            MsUserSelect: 'none',
            UserSelect: 'none'
        },
        flexItem: {
            padding: "0.25rem 0rem",
            transition:'0.4s all',
            borderRadius:'8px',
            backgroundColor:'#fec803'
        },
        liHeader: {
            padding:'0.8rem 0.4rem',
            cursor: 'pointer',
            fontWeight: '700',
            display:'flex',
            alignItems: 'center',
            transition:'0.4s all',
            justifyContent: 'center',
        },
        filterSelection: {
            width:'100%',
            textTransform:'uppercase', 
            display:'flex', 
            alignItems:'center',
            fontSize:'1rem',
        },
        crossIcon: {
            color:'#F0EFEC', 
            transition:'all 0.3s',
            transform:`rotate(45deg)`,
        },
        crossIconRotate: {
            transform:`rotate(0deg)`,
        },
        filter: {
            display:'flex', 
            flexDirection:'column', 
            gap:'0.2rem',
            transition:'all 0.4s'
        },
        filterOpen: {
            padding:'0.2rem 0.4rem 0.8rem 0.4rem',

        },
        internalContainer: {
            display: "flex",
            flexDirection:'column',
            height:'0px',
            fontFamily: "Montserrat",
            borderRadius: "1px",
            transition:'0.4s all',
            overflow:'hidden'
        },
        pageNameTitle:{
            fontFamily: "Montserrat",
            fontWeight: "700",
            letterSpacing: "1px",
            fontSize: "25px",
            color: '#fec803'
        },
        mailItem: {
            fontFamily: "Montserrat",
            fontWeight: "700",
            cursor:'pointer',
            height:'2.5rem',
            fontSize:'1rem',
            display:'flex',
            alignItems:'center',
            justifyContent:'start',
            /*tablet and bigger screens*/
            color:'#fec803',
            "@media (min-width: 1024px)": {
                height: "auto",
            }
        },

    });
    //#endregion

    //#region view
    return(
        <>
        {
            display?

        
        <div className={css(styles.container)}>
            <div className={css(styles.footer)}>
                <div className={css(styles.marginContainer)}>
                    
                    <div className={css(styles.secondColumn)}>
                        <div className={css(styles.linksContainerMobile)}>
                            <ul className={css(styles.ulContainer)}>
                                <li className={css(styles.flexItem)}>
                                    <div onClick={()=>showOrHideCheckBox("products")} className={css(styles.liHeader)}>
                                        <span className={css(styles.filterSelection)}>
                                            products
                                        </span>
                                        <span className={css(styles.crossIcon, !activeSections.includes("products") && styles.crossIconRotate)+ " material-icons"}>
                                            add
                                        </span>
                                    </div>
                                    <div className={css(styles.filter, activeSections.includes("products") && styles.filterOpen )}>
                                        <div className={css(styles.internalContainer)+" products"}>
                                            <Link className={css(styles.linkItem)} to="/products">All Products</Link>
                                            <Link className={css(styles.linkItem)} to="/products/dumpTrailer">Dump Trailers</Link>
                                            <Link className={css(styles.linkItem)} to="/products/fifthWheelCrane">Fifth Wheel Crane</Link>
                                            <Link className={css(styles.linkItem)} to="/products/arenaPlows">Sand Plows</Link>
                                            <Link className={css(styles.linkItem)} to="/products/ashLeveling">Leveling Ash</Link> 
                                        </div>
                                    </div>
                                </li>
                                <li className={css(styles.flexItem)}>
                                    <div onClick={()=>showOrHideCheckBox("all")} className={css(styles.liHeader)}>
                                        <span className={css(styles.filterSelection)}>
                                            all
                                        </span>
                                        <span className={css(styles.crossIcon, !activeSections.includes("all") && styles.crossIconRotate)+ " material-icons"}>
                                            add
                                        </span>
                                    </div>
                                    <div className={css(styles.filter, activeSections.includes("all") && styles.filterOpen )}>
                                        <div className={css(styles.internalContainer)+" all"}>
                                            <Link className={css(styles.linkItem)} to="/">Home</Link>
                                            <Link className={css(styles.linkItem)} to="/support">Support</Link>
                                            <Link className={css(styles.linkItem)} to="/about-us">About Us</Link>
                                        </div>
                                    </div>
                                </li>
                                <div className={css(styles.miniContainer)}>
                                <div className={css(styles.pageNameTitle)}>JF WELDING</div>
                                <div>
                                    <div className={css(styles.miniContainerText)}>+52 (625) 115 2516</div>
                                    <a className={css(styles.mailItem)} href="mailto:jfindustrias@yahoo.com">jfindustrias@yahoo.com</a>
                                </div>
                                <div className={css(styles.miniContainerText)}>
                                    <div>KM 36+900 #3690, Corredor</div>
                                    <div>Comercial, Cuauhtémoc,</div>
                                    <div>Chihuahua, MX.</div>
                                </div>
                            </div>
                            </ul>
                        </div>
                        <div className={css(styles.linksContainer)}>
                            <div className={css(styles.miniContainer)}>
                                <div className={css(styles.pageNameTitle)}>JF WELDING</div>
                                <div>
                                    <div className={css(styles.miniContainerText)}>+52 (625) 115 2516</div>
                                    <a className={css(styles.mailItem)} href="mailto:jfindustrias@yahoo.com">jfindustrias@yahoo.com</a>
                                </div>
                                <div className={css(styles.miniContainerText)}>
                                    <div>KM 36+900 #3690, Corredor</div>
                                    <div>Comercial, Cuauhtémoc,</div>
                                    <div>Chihuahua, MX.</div>
                                </div>
                            </div>
                            <div className={css(styles.miniContainer)}>
                                <span className={css(styles.miniContainerText)}>PRODUCTS</span>
                                <Link className={css(styles.linkItem)} to="/products">All Products</Link>
                                <Link className={css(styles.linkItem)} to="/products/dumpTrailer">Dump Trailers</Link>
                                <Link className={css(styles.linkItem)} to="/products/fifthWheelCrane">Fifth Wheel Crane</Link>
                                <Link className={css(styles.linkItem)} to="/products/arenaPlows">Arena Plows</Link>
                                <Link className={css(styles.linkItem)} to="/products/ashLeveling">Leveling Ash</Link> 
                            </div>
                            <div className={css(styles.miniContainer)}>
                                <span className={css(styles.miniContainerText)}>All</span>
                                <Link className={css(styles.linkItem)} to="/">Home</Link>
                                <Link className={css(styles.linkItem)} to="/support">Support</Link>
                                <Link className={css(styles.linkItem)} to="/about-us">About Us</Link>
                            </div>
                            

                        </div>
                    </div>
                </div>
            </div>
        </div>:<></>
        }
        </>
    );
    //#endregion
}
export default Footer